// @codekit-prepend 'functions.js'
// @codekit-prepend 'banner.js'
// @codekit-prepend 'email-subscription.js'
// @codekit-prepend 'videos.js'

// Initialisation of the Essay, when the DOM is ready
document.addEventListener('DOMContentLoaded', function(){

	// Banner
	window.addEventListener('load', bannerSetup);
	window.addEventListener('scroll', bannerScroll);

	// Email Newsletter
	window.addEventListener('load', emailSetup);
	window.addEventListener('scroll', emailForm);

	// Videos
	window.addEventListener('scroll', trackVideos);

	// Print button
	const printButton = document.querySelector('a[title="Print"]');
	if (printButton !== null) {
		printButton.style.display = 'block';
		printButton.addEventListener('click', function(){
			window.print();
		}, false);
	}

}, false); // end of Essay
